import { TUser } from '../../types/redux';

const defaultState: TUser = {
  isAuthenticated: false,
};

export function userReducer(state: TUser = defaultState) {
  return state;
}
